export const activeHomeWork = state => state.activeHomeWork

export const historyWorkList = state => state.historyWorks

export const classList = state => state.classList

export const stuHomeWork = state => state.stuHomeWork

export const peerReviewHomeworkList = state => state.peerReviewHomeworkList

export const peerTask = state => state.peerTasks

export const marks = state => state.marks

export const attach = state => state.attach

export const isLoading = state => state.isLoading

export const courseRole = state => state.courseRole



// WEBPACK FOOTER //
// ./src/store/getters.js